module.exports = __webpack_public_path__ + "images/new_spinner.svg";